/*global dataLayerCustomLabelFormTracker, createDataLayerObject*/
import { dataLayerCustomLabelFormTracker, createDataLayerObject } from './data-layer-helper';
$(function () {
    var currentCategory = 'MV Renovation';
    dataLayerCustomLabelFormTracker('start-renovation-form', currentCategory, 'StartedRenovation', 'Renovation started');
    dataLayerCustomLabelFormTracker('finished-renovation-form', currentCategory, 'FinishedRenovation', 'Renovation finished');
    // Chosen
    dataLayerRenovationTeaserTracker('card--add-new', 'ClickAvailableRenovation', 'Renovation chosen');
    function dataLayerRenovationTeaserTracker(className, eventName, eventAction) {
        var teasers = $('.' + className);
        if (teasers.length < 1) {
            return;
        }
        if (!teasers.is('a')) {
            return;
        }
        teasers.each(function (index, teaser) {
            var $teaser = $(teaser);
            var customLabel = $teaser.data('label-name');
            var activeRenovation = $teaser.data('active-renovation');
            $teaser.click(function () {
                var dataLayerObj = createDataLayerObject(eventName, currentCategory, eventAction, customLabel);
                dataLayerObj['eventValue'] = activeRenovation ? 1 : 0;
                window['dataLayer'].push(dataLayerObj);
            });
        });
    }
});
